var _path, _path2, _path3, _path4, _path5, _path6, _rect, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 673,
    height: 217,
    viewBox: "0 0 673 217",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M272.998 76.116V140.286H328.426V130.149H286.018V112.386H318.382V102.621H286.018V86.253H328.054V76.116H272.998Z",
    fill: "#FF0032"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M346.73 140.286L368.306 115.734L389.975 140.286H405.599L376.769 107.55L404.39 76.116H390.068L369.329 99.831L348.497 76.116H332.873L360.866 108.015L332.501 140.286H346.73Z",
    fill: "#FF0032"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M468.124 111.363C468.124 125.778 459.754 131.265 443.2 131.265C426.553 131.265 418.276 125.685 418.276 111.363V104.76C418.276 90.624 426.553 85.137 443.2 85.137C459.754 85.137 468.124 90.624 468.124 104.76V111.363ZM405.163 107.922C405.163 132.66 418.369 141.402 443.2 141.402C468.031 141.402 481.237 132.66 481.237 107.922C481.237 83.556 468.031 75 443.2 75C418.369 75 405.163 83.556 405.163 107.922Z",
    fill: "#FF0032"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M492.783 76.116V140.286H545.049V129.684H505.803V76.116H492.783Z",
    fill: "#FF0032"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M597.053 76.116L573.245 130.893L549.623 76.116H535.673L563.666 140.286H581.243L609.329 76.116H597.053Z",
    fill: "#FF0032"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M616.935 76.116V140.286H672.363V130.149H629.955V112.386H662.319V102.621H629.955V86.253H671.991V76.116H616.935Z",
    fill: "#FF0032"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 216.88,
    height: 216.88,
    fill: "#FF0032"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M70.402 32.8304H36.8091V86.5099H80.6693V130.37H36.8091V184.05H70.402L112.429 130.37V86.5099L70.402 32.8304Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M146.04 32.8304H112.427V86.5099H156.307V130.37H112.427V184.05H146.04L188.046 130.37V86.5099L146.04 32.8304Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.774124a9025bfda314ead7432405ae1d.svg";
export { ForwardRef as ReactComponent };